import { Modal } from "@components";
import { useDocumentSignatureContext } from "@contexts";

interface Props {
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
}

export function WrongPinDocumentSignatureErrorModal({
  onPrimaryAction,
  onSecondaryAction,
}: Props) {
  const { showInvalidPinErrorModal, setShowInvalidPinErrorModal } =
    useDocumentSignatureContext();

  return (
    <Modal
      title="PIN incorrecto"
      content={
        <span>
          El PIN de 4 dígitos ingresado no es válido. Intenta nuevamente.
          <br />
          <br />
          Luego de 3 intentos fallidos, se bloqueará el PIN.
        </span>
      }
      isOpen={showInvalidPinErrorModal}
      buttonProps={{
        buttonText: "Reintentar",
        onClick: () => {
          setShowInvalidPinErrorModal(false);
          onPrimaryAction?.();
        },
      }}
      secondaryButtonProps={{
        buttonText: "Volver a inicio",
        onClick: () => {
          setShowInvalidPinErrorModal(false);
          onSecondaryAction?.();
        },
      }}
    />
  );
}
